import { render } from "./MenuMovil.vue?vue&type=template&id=652c8a81&scoped=true"
import script from "./MenuMovil.vue?vue&type=script&lang=js"
export * from "./MenuMovil.vue?vue&type=script&lang=js"

import "./MenuMovil.vue?vue&type=style&index=0&id=652c8a81&scoped=true&lang=scss"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652c8a81"]])

export default __exports__